import { service } from '@ember/service';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import ConversationList from './conversation-list.gjs';
import NavigationBar from './navigation-bar.gjs';
import styles from './ember-messaging-client.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class EmberMessagingClient extends Component {
  @service messaging;

  <template>
    <div class="{{styles.component}} messaging-client" data-test-ember-messaging-client>
      <NavigationBar />
      {{#if this.messaging.loadApp.isRunning}}
        <div class="spinner" data-test-loading-spinner>
          {{svgJar "messaging-spinner"}}
        </div>
      {{else if this.messaging.conversations}}
        <ConversationList @conversations={{this.messaging.conversations}} />
      {{else}}
        <div class="empty-conversation-list" data-test-empty-conversation-list>
          {{svgJar "messaging-welcome"}}
          <h3 class="empty-list-header" data-test-empty-header>{{t "empty_list_header"}}</h3>
          <p class="empty-list-text" data-test-empty-text>{{t "empty_list_text"}}</p>
          {{! Create message button goes here }}
        </div>
      {{/if}}
    </div>
  </template>
}
